import * as mac from "@/data/api/mac"
import {User} from "@/data/repos/authUser"
import {getTestData} from "@/data/repos/mockDataLoader"

interface Panel {
  id?: number,
  userId: number,
  name: string,
  system: boolean,
  ownerInfo?: User,
  sharedWithUsers?: number[],
  canShare: boolean,
  canDelete: boolean,
}

interface PanelList {
  [key: number]: Panel
}

interface ErrorResponse {
  errorMessage: string,
}

export async function panelsList(): Promise<PanelList | ErrorResponse> {
  if (process.env.NODE_ENV === "test") {
    return panelsTransform(await getTestData("panels"))
  }
  try {
    const r = await mac.api.get("panels")
    if (!r) { return { errorMessage: "Request failed"} as ErrorResponse }
    return panelsTransform(r.data)
  } catch (err) {
    return err.response.data as ErrorResponse
  }
}

function panelsTransform(data: any[]): PanelList {
  const filteredData: PanelList = {}
  for (const item of data) {
    filteredData[item.id] = item
    filteredData[item.id].ownerInfo = {} as User
  }
  return filteredData
}

export async function panelCreate(
  name: string): Promise<Panel> {
  // In:  {        "name":"Some Panel"}
  // Out: {"id":2, "name":"Some Panel"}
  try {
    const r = await mac.api.post("panel/create", {name})
    return r.data
  } catch (err) {
    console.error("panelUpdate failed:", err)
    return {} as Panel
  }
}

export async function panelUpdate(id: number, userId: number, name: string): Promise<any[]> {
  // In:  {"id":2, "userId":1, "name":"Some Panel"}
  // Out: {"id":2, "userId":1, "name":"Some Panel"}
  try {
    const r = await mac.api.post("panel/update", {id, userId, name})
    return r.data
  } catch (err) {
    console.error("panelUpdate failed:", err)
    return []
  }
}

export async function duplicatePanel(existingPanelId: string, newPanelName: string): Promise<number | undefined> {
  // In:  {"existingPanelId":2, "newPanelName":"New panel"}
  // Out: {"newPanelId":}
  try {
    const r = await mac.api.post("panel/clone", {existingPanelId, newPanelName})
    return r.data.newPanelId
  } catch (err) {
    console.error("duplicatePanel failed", err)
  }
}

export async function panelDelete(
  id: number): Promise<boolean> {
  // In:  {"id":2}
  // Out: {}
  try {
    const r = await mac.api.post("panel/delete", {id})
    return r.data.errorCode === undefined
  } catch (err) {
    console.error("panelUpdate failed:", err)
    return false
  }
}

export enum ShareMode {
  private = "private",
  public = "public",
  users = "users",
}

export interface ShareRequest {
  id: number,
  share: ShareMode,
  panelUrl?: string,
  sharedWithUsers?: number[],
}

export async function panelShare(
  shareRequest: ShareRequest): Promise<any> {
  // In:  {"id":2, "share":"link", "sendEmail": ["user1@org.com", "user2@org.com"],
  //       "panelUrl":"http://localhost:8080/panel/41"}
  // Out: {"id":2, "system":false, "shareToken":"6bm5oqb7rwb8gzirdb15xn8tarswoj56pu3ucsbwdwrn4f8ub5"}
  try {
    const r = await mac.api.post("panel/share", shareRequest)
    return r.data
  } catch (err) {
    console.error("panelShareByLink failed:", err)
    return false
  }
}
